import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import AppRouter from './_routers/AppRouter';
import Firebase, { FirebaseContext } from './_firebase';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { GlobalStyles } from '@mui/material';

ReactDOM.render(
  <FirebaseContext.Provider value={new Firebase()}>
    <ThemeProvider theme={theme}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <CssBaseline />
      <GlobalStyles
        styles={{
          '*': {
            fontFamily: '"Cabin", sans-serif!important'
          },
        }}
      />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ fontSize: 16, width: 600 }}
      />
      <AppRouter />
    </ThemeProvider>
  </FirebaseContext.Provider>,
  document.querySelector('#root'),
);